import { render } from "./CustomCalendar.vue?vue&type=template&id=a3f92e74&scoped=true"
import script from "./CustomCalendar.vue?vue&type=script&lang=js"
export * from "./CustomCalendar.vue?vue&type=script&lang=js"

import "./CustomCalendar.vue?vue&type=style&index=0&id=a3f92e74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3f92e74"]])

export default __exports__